import Vue from 'vue';

const state = {
	shipping_bg: '',
	delivery_bg: '',
	quote_bg: '',
	completed_steps: 0,
	// Array of steps based on the routing for each one
	// The step number is caluclating based on array index + 1
	steps: [
		{
			name: 'Pickup',
		},
		{
			name: 'Size',
			quoteProps: ['origin'],
		},
		{
			name: 'Shipping',
			quoteProps: ['moveSize'],
		},
		{
			name: 'Delivery',
			quoteProps: ['moveDate'],
		},
		{
			name: 'Quote-Name',
			quoteProps: ['delivery'],
		},
		{
			name: 'Quote-Email',
			quoteProps: ['firstName', 'lastName'],
		},
		{
			name: 'Quote-Phone',
			quoteProps: ['email'],
		},
		{
			name: 'Quote-Text-Verify',
			quoteProps: ['origin', 'delivery', 'firstName', 'lastName', 'email', 'phone'],
		},
		// {
		// 	name: 'Auto',
		// 	quoteProps: ['phone'],
		// },
		{
			name: 'Thank-You',
			quoteProps: ['phone'],
		},
	],
};

const getters = {
	isValidRoute: (state, getters, rootState) => step => {
		let completedSteps = state.completed_steps;
		let isValid = true;

		if (!completedSteps) {
			completedSteps = Vue.$session.get('completed_steps') || 0;
		}

		Vue.$log.info('isValidRoute | ', rootState, state, step, completedSteps);

		// if (step - 1 > parseInt(completedSteps)) {
		// 	return false;
		// }

		if (step.hasOwnProperty('quoteProps')) {
			for (const prop of step.quoteProps) {
				Vue.$log.debug(prop, step.quoteProps);

				if (Vue.$iUtils.isEmpty(rootState.quote[prop])) {
					isValid = false;

					return false;
				}
			}
		}

		if (isValid && !completedSteps) {
			isValid = false;
		}

		return isValid;
	},

	getProgress: (state, getters) => step => {
		Vue.$log.debug('getProgress | ', step);
		const progress = (step * 100) / getters.totalSteps;

		return progress;
	},

	getNextStep: state => {
		const currStep = state.completed_steps;

		Vue.$log.debug('getNextStep->', currStep);

		return state.steps[currStep];
	},

	getStepByIndex: state => index => {
		return state.steps[index];
	},

	getStepByName: state => name => {
		let stepIndex = 0;

		Vue.$log.debug('getStepByName | name->', name, 'state->', state);

		if (name === 'NotFound') {
			return -1;
		}

		const step = state.steps.find((step, index) => {
			stepIndex = index;

			return step.name === name;
		});

		Vue.$log.debug('step->', step);

		if (step && step.parent) {
			return stepIndex;
		}

		return stepIndex + 1;
	},

	totalSteps: state => {
		return state.steps.length - 2;
	},
};

const actions = {
	updateProgress: function({ dispatch }, step) {
		dispatch('updateProgressByStep', step);
	},

	updateProgressByStep({ commit, rootState, dispatch }, step) {
		this._vm.$log.info(rootState, step);

		if (!rootState.iframeFlag && step > 2) {
			switch (step) {
				case 3:
				case 4:
					dispatch('updateShippingBg');
					break;
				case 5:
				case 6:
				case 7:
				case 8:
					dispatch('updateQuoteBg');
					break;
			}
		}

		commit('SET_COMPLETED_STEPS', step);

		if (!state.completed_steps || step > parseInt(state.completed_steps)) {
			commit('SET_COMPLETED_STEPS', step - 1);
		}

		this._vm.$session.set('completed_steps', state.completed_steps);
	},

	updateShippingBg({ commit, state, rootState }) {
		const size = rootState.quote.moveSize.type;
		const image = require(`@/assets/when-${size}.png`);

		commit('SET_BACKGROUND', { type: 'shipping_bg', image });
	},
	// updateDeliveryBg({ commit, rootState }) {
	// 	const size = rootState.quote.moveSize.type;

	// 	if (size) {
	// 		this._vm.$log.debug(rootState);
	// 		const image = require(`@/assets/to-${size}.png`);

	// 		commit('SET_BACKGROUND', { type: 'delivery_bg', image });
	// 	}
	// },
	updateQuoteBg({ commit, rootState, state }) {
		const size = rootState.quote.moveSize.type;

		if (size && !state.quote_bg) {
			const image = require(`@/assets/quote-${size}.gif`);

			commit('SET_BACKGROUND', { type: 'quote_bg', image: `${image}?x=${Date.now()}` });
		}
	},
};

const mutations = {
	SET_BACKGROUND(state, payload) {
		this._vm.$log.debug(payload);

		state[payload.type] = payload.image;
	},

	SET_COMPLETED_STEPS(state, completed) {
		state.completed_steps = completed;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
